module.exports = __webpack_public_path__ + "static/media/RulesEnginePic.eca847b1.png";